import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { useSticky, fillBetween } from './StickyHook';

const StickyBetween = (props) => {
    const {
        children,
        stickyParentBlock,
        shouleObserveForResize = false,
        offSetTopParent,
        mainContainerHeightOverride,
        adjustHeightForQSBanner,
    } = props;
    const [parentHeight, setParentHeight] = useState(0);
    const stickyNavConfig = {
        context: 'stickyContext',
        plugin: throttle(fillBetween, 1),
    };
    useEffect(() => {
        if (shouleObserveForResize) {
            if (!stickyParentBlock.current) return;
            const resizeObserver = new ResizeObserver(() => {
                setParentHeight(
                    mainContainerHeightOverride
                        ? mainContainerHeightOverride - (offSetTopParent?.current?.offsetTop || 0)
                        : stickyParentBlock?.current?.clientHeight -
                              (offSetTopParent?.current?.offsetTop || 0)
                );
            });
            resizeObserver.observe(stickyParentBlock.current);
            return () => resizeObserver.disconnect(); // clean up
        }
        setParentHeight(
            mainContainerHeightOverride
                ? mainContainerHeightOverride - offSetTopParent?.current?.offsetTop
                : stickyParentBlock?.current?.clientHeight - offSetTopParent?.current?.offsetTop
        );
    }, []);
    const { createBoundary } = useSticky(stickyNavConfig);
    const dynamicParentHeight = adjustHeightForQSBanner ? `${parentHeight - 360}` : parentHeight;
    return (
        <div className={dt(['relative', 'flex', 'w-full', 'h-full'])} ref={createBoundary('outer')}>
            <div
                className={dt(['invisible', 'flex', 'flex-col'])}
                style={{ height: `${dynamicParentHeight}px` }}
            />
            <div
                className={`${dt(['flex', 'flex-col', 'w-full'])} stickycomponent`}
                ref={createBoundary('sticky')}
                style={{ 'max-height': `${dynamicParentHeight}px` }}
            >
                {children}
            </div>
        </div>
    );
};

StickyBetween.propTypes = {
    children: PropTypes.element,
    stickyParentBlock: PropTypes.element,
    shouleObserveForResize: PropTypes.bool,
    offSetTopParent: PropTypes.element,
    mainContainerHeightOverride: PropTypes.number,
    adjustHeightForQSBanner: PropTypes.bool,
};

StickyBetween.defaultProps = {
    children: '',
    stickyParentBlock: '',
    shouleObserveForResize: false,
    offSetTopParent: '',
    mainContainerHeightOverride: null,
    adjustHeightForQSBanner: false,
};

export default StickyBetween;
